export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 30;

const SEQUENTIAL_MIN_LENGTH = 3;

export function hasSequentialDigits(
  value: string,
  minLength = SEQUENTIAL_MIN_LENGTH,
): boolean {
  const digits = value.replace(/\D/g, '');

  if (digits.length < minLength) {
    return false;
  }

  for (let start = 0; start <= digits.length - minLength; start += 1) {
    let ascending = true;
    let descending = true;

    for (let offset = 0; offset < minLength - 1; offset += 1) {
      const current = Number(digits[start + offset]);
      const next = Number(digits[start + offset + 1]);

      if (next !== current + 1) {
        ascending = false;
      }

      if (next !== current - 1) {
        descending = false;
      }
    }

    if (ascending || descending) {
      return true;
    }
  }

  return false;
}

export function passwordContainsUserFirstName(
  password: string,
  userName?: string | null,
): boolean {
  if (!userName || !password) {
    return false;
  }

  const valueFormatted = password
    .toLowerCase()
    .trim()
    .replace(/[^a-z]/g, '');

  const firstName = userName
    .trim()
    .split(' ')[0]
    .toLowerCase()
    .replace(/[^a-z]/g, '');

  if (!firstName) {
    return false;
  }

  const regex = new RegExp(
    firstName
      .split('')
      .map((char) => `${char}+`)
      .join('.*'),
    'i',
  );

  return regex.test(valueFormatted);
}
